"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TablePaginationActions.default;
  }
});

var _TablePaginationActions = _interopRequireDefault(require("./TablePaginationActions"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/TablePaginationActions/index.js
// module id = 536
// module chunks = 0